import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenshare = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20,8L20,22",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16,12L20,8L24,12",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeWidth: 2,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25,16L30,16L30,28L10,28L10,16L15,16",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgScreenshare);
export default ForwardRef;
